const state = {
  env: {}
};

export default state;
